import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { BrandInstance } from "../utils/brandClass";
import { VenueInstance } from "../utils/venueClass";
import { isBrand } from "../typeHelpers/typeCheck";
import MenuAddProductFromBrandItem from "./menuAddProductFromBrandItem";
import btnStyles from "../styles/globalButtonStylng.module.css"


export const MenuAddProductFromBrandListModal = ({ brandSelected, closeModal, fetchMenuProducts }: {
    brandSelected: Brand | null | undefined; closeModal: Function,
    fetchMenuProducts: Function
}) => {
    const [filteredProducts, setFilteredProducts] = useState<Product[]>([]);
    const { activeBusiness } = useSelector((state: any) => state.business)
    const [brandName, setBrandName] = useState<string>("");
    const [productsToAdd, setProductsToAdd] = useState<any>([]);

    //get products from brandSelected via id
    useEffect(() => {
        fetchProducts()
    }, [])

    useEffect(() => {
        console.log("products filtered", filteredProducts);
    }, [filteredProducts]);

    useEffect(() => {
        console.log("products to add", productsToAdd);
    }, [productsToAdd]);

    //fetch product asynchronously
    const fetchProducts = async () => {
        if (isBrand(brandSelected)) {
            setBrandName(brandSelected.name);
            try {
                const fetchedProducts = await BrandInstance.getProducts(brandSelected.id.toString());

                const venueMenu = await VenueInstance.getMenu(activeBusiness.id.toString());

                if (venueMenu !== undefined) {
                    const filteredProducts = fetchedProducts.filter((p: Product) => {
                        return !venueMenu.find((m: Product) => m.id === p.id)
                    });
                    setFilteredProducts(filteredProducts)
                } else {
                    setFilteredProducts(fetchedProducts)
                }
            } catch (error) {
                console.error("failed to get product from brand");
            }
        }
    }

    const addItem = (newItem: any) => {
        setProductsToAdd((prev: any) => [...prev, newItem]);
    }

    const removeItem = (itemId: any) => {
        const removed = productsToAdd.filter((a: any) => a.id !== itemId);
        setProductsToAdd(removed);
    }

    const submitItemsToMenu = async () => {
        try {
            // TODO: CREATE AN ENDPOINT THAT TAKES IN THE ENTIRE ARRAY ON BACKEND AND DOES THIS
            await Promise.all(
                productsToAdd.map((p: any) => {
                    VenueInstance.addMenuItem(activeBusiness.id, p);
                })
            );

            await fetchMenuProducts();
            closeModal();
        } catch (error) {
            console.log("couldn't add products to menu");
        }
    }

    return (
        <>
            <p>Select from the following products offered by {brandName}</p>
            <div className="row">
                <div className="col-sm-1"></div>
                <div className="col-sm-4 text-wrap">Name</div>
                <div className="col-sm-3">Category</div>
                <div className="col-sm-2">Strain</div>
                <div className="col-sm-2">Action</div>
            </div>
            {filteredProducts?.map((p: Product, index: number) => (
                <MenuAddProductFromBrandItem product={p} addItem={addItem} removeItem={removeItem} />
            ))}
            <div className="d-flex justify-content-center">
                <button className={btnStyles.Submit} onClick={submitItemsToMenu}>Add Selected Items</button>
            </div>
        </>
    )
}